const STORAGE_KEY = "ap_tableCols_v1";

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function loadTablePrefs(tableId) {
  const row = readAll()[tableId] || {};
  return {
    hidden: Array.isArray(row.hidden) ? row.hidden.map(String) : [],
    labels: row.labels && typeof row.labels === "object" ? row.labels : {},
  };
}

export function saveTablePrefs(tableId, prefs) {
  const all = readAll();
  all[tableId] = {
    hidden: Array.isArray(prefs?.hidden) ? prefs.hidden.map(String) : [],
    labels: prefs?.labels && typeof prefs.labels === "object" ? prefs.labels : {},
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  } catch {
    /* ignore quota */
  }
}

export function filterAoaByIndexes(aoa, keepIndexes) {
  const keep = (keepIndexes || []).filter((i) => Number.isInteger(i) && i >= 0);
  if (!keep.length) return aoa;
  return (aoa || []).map((row) => keep.map((i) => (Array.isArray(row) ? row[i] : "")));
}
